<template>
  <div>
    <!-- <NavBar v-if="isDataFetched()" class="no-print"></NavBar> -->
    <div class="pusher">
      <div class="ui grid container admin-user">
        <div class="two wide column">
          <SideBar v-if="isDataFetched()" class="no-print"></SideBar>
        </div>
        <div class="fourteen wide column">
          <div v-if="!isDataFetched() || isEmpty(this.settings)"
              class="ui active inverted dimmer loader-margin">
            <div class="ui text loader">loading...</div>
          </div>
          <div v-else class="content">
            <slot name="layout"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
    NavBar: require('@/components/layouts/NavBar').default,
    SideBar: require('@/components/layouts/SideBar').default
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.admin-user {
  margin-top: 10px;
}

.loader-margin {
  margin-top: 30%;
}

@media print {
  .admin-user {
    margin-top: 0px;
  }
}

  .content {
  }
</style>



// WEBPACK FOOTER //
// src/components/layouts/WebLayout.vue